import type React from 'react'
import { defineMessages, useIntl } from 'react-intl'
import styled from 'styled-components'

import { AssistantIcon } from '@components/ui/svgIcons'

import { generateMaxHeightBreakPoint } from '@constants'

import { useIntercomUnreadMessagesCount } from './AppIntercomProvider'
import { IntercomLauncherButton, IntercomLauncherIconButton } from './IntercomLauncherButtons'
import { IntercomUnreadCountBadge } from './IntercomUnreadCountBadge'

const messages = defineMessages({
  text: { id: 'navLink.assistant', defaultMessage: 'Súgó' },
})

const StyledIconButton = styled(IntercomLauncherIconButton)`
  height: ${({ theme }) => theme.appBarHeight}px;
  padding: 0;
  width: 50px;
  border-radius: 0;

  &::before {
    border: none;
  }

  ${generateMaxHeightBreakPoint('medium')} {
    height: ${({ theme }) => theme.appBarHeightMedium}px;
  }
`

// styled as old mui button to match styles with logout button in mobile view
const StyledButton = styled(IntercomLauncherButton)`
  justify-content: flex-start;
  font-weight: 500;
  padding: 0 8px;
  font-size: 1rem;
  height: 50px;
`

interface PrivateNavbarIntercomLauncherButtonProps {
  className?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  showIconButton?: boolean
}

function QuickCustomIntercomLauncherIconButton(props: {
  className?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}) {
  const { formatMessage } = useIntl()
  const count = useIntercomUnreadMessagesCount()
  return (
    <StyledIconButton title={formatMessage(messages.text)} {...props}>
      <IntercomUnreadCountBadge count={count} />
      <AssistantIcon color="currentColor" />
    </StyledIconButton>
  )
}

export function PrivateNavbarIntercomLauncherButton({
  className,
  onClick,
  showIconButton = false,
}: PrivateNavbarIntercomLauncherButtonProps) {
  const { formatMessage } = useIntl()

  if (showIconButton) {
    return <QuickCustomIntercomLauncherIconButton className={className} onClick={onClick} />
  }

  return (
    <StyledButton fullWidth className={className} variant="secondaryText" onClick={onClick}>
      {formatMessage(messages.text)}
    </StyledButton>
  )
}
